// Константы для Form4

// Функция для получения пустых данных формы
export const getEmptyFormData = () => {
  return {
    // Данные таблицы
    data: [{
      id: 1,
      yarus: '',           // Ярус
      dolap: '',           // Доля
      kodporoda: '',       // Порода
      vozr: '',            // Ср. возраст, лет
      hsr: '',             // Ср. высота, м
      dsr: '',             // Ср. диаметр, см
      // Новые столбцы для санитарного состояния
      bpodolap: 100,       // I (здор) - вычисляемое поле, изначально 100
      osldolap: 0,         // II (ослаб) - изначально 0
      sosldolap: 0,        // III (с.осл.) - изначально 0
      usdolap: 0,          // IV (усых) - изначально 0
      svsuhdolap: 0,       // VA (св.сс.) - изначально 0
      svvtrdolap: 0,       // VБ (св.вв.) - изначально 0
      svburdolap: 0,       // VВ (св.бл) - изначально 0
      stsuhdolap: 0,      // VГ (ст.сс) - изначально 0
      stvtrdolap: 0,       // VД (ст.вв) - изначально 0
      stburdolap: 0,      // VЕ (ст.бл) - изначально 0
      // Новые поля для СКС и отпада
      sksporoda: '',       // СКС
      ooporoda: '',        // Отпад (общ)
      toporoda: ''         // Отпад (тек)
    }],
    form4ValidationErrors: false, // По умолчанию false, так как все поля необязательные
    charochag: '',         // Характер усыхания насаждения
    itaks4: ''             // Информация пользователя
  };
};

